import React from "react";

import LogService from "../../../middleware/CommonSdk/LogService";
import PropTypes from "prop-types";

const LOG_TAG = "VIDEO_CHANNEL_ITEM";

const VideoChannelItem = (props) => {
    LogService.trace(LOG_TAG, "Enter");

    let videos = null; 
    if (props.entry && props.entry.video) {
        if (props.entry.video.length > 0) {
            videos = props.entry.videos.map((video, index) => (
                <div key={`video-${index}`} className="embed-responsive embed-responsive-16by9">
                    <iframe
                        loading="lazy"
                        className="embed-responsive-item"
                        src={"https://www.youtube.com/embed/"+ video.id}
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        title={`video-${index}`}
                        allowFullScreen
                    />
                </div>
            ));
        } else {
            videos = <div key="video-0" className="embed-responsive embed-responsive-16by9">
                <iframe
                    loading="lazy"
                    className="embed-responsive-item"
                    src={"https://www.youtube.com/embed/"+ props.entry.video.id}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    title="video-1"
                    allowFullScreen
                />
                </div>
        }
    }    

    return (<div>{videos}</div>);
}

VideoChannelItem.propTypes = {
    entry: PropTypes.object
}

export default VideoChannelItem;